import { ozToLb } from './conversions'

export const formatWeight = (weight: number) => {
  return `${ozToLb(weight).toFixed(2)} lb`
}

export const lbToOz = (weight = 0) => {
  return weight * 16
}
